import { FC } from 'react';
import { SkeletonTable } from './SkeletonTable';

/** Панель списка диалогов в превью раскладки */
export const SkeletonTableLayout: FC = () => (
  <div className={'w-48 h-24 border-border border rounded-md flex p-1.5 items-center gap-1.5 overflow-hidden'}>
    <SkeletonTable />
  </div>
);
